import React from 'react';
import { Link } from 'react-router-dom';
import BrandLogo from './BrandLogo';
import useSiteSettings from '../hooks/useSiteSettings';

const FooterLink = ({ to, children, testId }) => (
  <Link
    to={to}
    className="text-sm text-sand-100 hover:text-sand-50 transition-colors"
    data-testid={testId}
  >
    {children}
  </Link>
);

const Footer = () => {
  const year = new Date().getFullYear();
  const settings = useSiteSettings();
  return (
    <footer className="bg-text-primary text-sand-50 py-12 px-4 sm:px-8" data-testid="site-footer">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-8 pb-8 border-b border-sand-50/10">
          <div className="md:max-w-sm">
            <div className="mb-3 inline-flex">
              <BrandLogo size="lg" linkTo={null} />
            </div>
            <p className="text-sm text-sand-100 leading-relaxed">
              Making your special moments unforgettable. Plan weddings, birthdays and more with instant pricing.
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 gap-8">
            <div>
              <div className="text-xs tracking-[0.2em] uppercase font-bold mb-3 text-sand-100">Explore</div>
              <ul className="space-y-2">
                <li><FooterLink to="/instant-pricing" testId="footer-pricing">Instant Pricing</FooterLink></li>
                <li><FooterLink to="/register" testId="footer-register">Join BeeWeddy</FooterLink></li>
              </ul>
            </div>

            <div>
              <div className="text-xs tracking-[0.2em] uppercase font-bold mb-3 text-sand-100">Legal</div>
              <ul className="space-y-2">
                <li><FooterLink to="/privacy-policy" testId="footer-privacy">Privacy Policy</FooterLink></li>
                <li><FooterLink to="/terms" testId="footer-terms">Terms of Service</FooterLink></li>
                <li><FooterLink to="/refund-policy" testId="footer-refund">Refund Policy</FooterLink></li>
                <li><FooterLink to="/delete-my-account" testId="footer-delete-account">Delete My Account</FooterLink></li>
              </ul>
            </div>

            <div>
              <div className="text-xs tracking-[0.2em] uppercase font-bold mb-3 text-sand-100">Contact</div>
              <ul className="space-y-2 text-sm text-sand-100">
                <li><a href={`mailto:${settings.support_email}`} className="hover:text-sand-50" data-testid="footer-support-email">{settings.support_email}</a></li>
                <li><a href={`tel:${settings.phone.replace(/\s/g, '')}`} className="hover:text-sand-50" data-testid="footer-phone">{settings.phone}</a></li>
                <li data-testid="footer-address">{settings.address}</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="pt-6 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 text-xs text-sand-100">
          <div data-testid="footer-copyright">
            © {year} {settings.company_name}.{settings.owner_name ? ` Owned by ${settings.owner_name}.` : ''} All rights reserved.
          </div>
          <div>Made with care in India 🇮🇳</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
